import React from "react";
import "./AdminModalFooter.css";

/**
 * Reusable modal footer component for Admin modals
 * Provides consistent Cancel and Submit button layout
 */
const AdminModalFooter = ({
  onCancel,
  onSubmit,
  cancelText = "Cancel",
  submitText = "Save",
  submitType = "submit",
  isSubmitting = false,
  submitDisabled,
  className = ""
}) => {
  const disabled = isSubmitting || submitDisabled;
  return (
    <div className={`admin-modal-footer ${className}`}>
      <button
        type="button"
        className="admin-btn-cancel"
        onClick={onCancel}
        disabled={isSubmitting}
      >
        {cancelText}
      </button>
      <button
        type={submitType}
        className="admin-btn-submit"
        onClick={onSubmit}
        disabled={disabled}
      >
        {submitText}
      </button>
    </div>
  );
};

export default AdminModalFooter;
